/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type InitiateCallInput = {
    readonly buyerId: string;
    readonly buyerName: string;
    readonly buyerNumber: string;
    readonly buyerCountryCode: number;
    readonly dealerId: string;
    readonly itemId?: string | null;
    readonly itemName?: string | null;
    readonly saveName?: boolean | null;
    readonly savePhoneNumber?: boolean | null;
    readonly phoneCallbackEnabled?: boolean | null;
    readonly callbackPhoneId?: string | null;
    readonly clientMutationId?: string | null;
};
export type InitiateCallMutationVariables = {
    readonly input: InitiateCallInput;
};
export type InitiateCallMutationResponse = {
    readonly initiateCall: {
        readonly success: boolean;
        readonly errors: ReadonlyArray<{
            readonly message: string | null;
        } | null> | null;
    } | null;
};
export type InitiateCallMutation = {
    readonly response: InitiateCallMutationResponse;
    readonly variables: InitiateCallMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "InitiateCallInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "initiateCall",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "InitiateCallPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "success",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "errors",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GraphQLError",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "message",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "InitiateCallMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "InitiateCallMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "InitiateCallMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/InitiateCallMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '53bc9d8798f7475aca3b0a9b059c924d';
export default node;
